// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-login {
  overflow: hidden !important;
}
.main-login .wrapper .left {
  background-color: #f1f3f6 !important;
  position: relative;
}
.main-login .wrapper .left .logo {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, rgba(0, 126, 204, 0.3411764706) 0%, rgba(236, 0, 140, 0.2509803922) 100%);
}
.main-login .wrapper .left .logo img {
  height: 30%;
}
.main-login .wrapper .right {
  padding: 30px;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-login .wrapper .right .inner-form {
  width: 100%;
}
.main-login .wrapper .right .inner-form .form-control {
  height: 38px;
}
.main-login .wrapper .right .inner-form .login-btn-main {
  text-align: center;
}
.main-login .wrapper .right .inner-form .login-btn-main .innerLink {
  text-decoration: none !important;
}
.main-login .wrapper .right .inner-form .login-btn-main .innerLink button {
  width: 100%;
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  border-radius: 0px 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-login .wrapper .right .inner-form .form-label {
  color: #000;
}
.main-login .wrapper .right .inner-form .heading-login label {
  color: #000;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/login.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;AAEI;EACE,oCAAA;EACA,kBAAA;AAAN;AAEM;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6GAAA;AAAR;AACQ;EACE,WAAA;AACV;AAII;EACE,aAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAIM;EAiCE,WAAA;AAlCR;AAEQ;EACE,YAAA;AAAV;AAGQ;EACE,kBAAA;AADV;AAGU;EACE,gCAAA;AADZ;AAGY;EACE,WAAA;EACA,iEAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFd;AAOQ;EACE,WAAA;AALV;AAWU;EACE,WAAA;EACA,eAAA;AATZ","sourcesContent":[".main-login {\n  overflow: hidden !important;\n\n  .wrapper {\n    .left {\n      background-color: #f1f3f6 !important;\n      position: relative;\n\n      .logo {\n        height: 100vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: linear-gradient(180deg, #007ecc57 0%, #ec008c40 100%);\n        img {\n          height: 30%;\n        }\n      }\n    }\n\n    .right {\n      padding: 30px;\n      height: 100vh;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .inner-form {\n        .form-control {\n          height: 38px;\n        }\n\n        .login-btn-main {\n          text-align: center;\n\n          .innerLink {\n            text-decoration: none !important;\n\n            button {\n              width: 100%;\n              background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n              border-radius: 0px 10px;\n              font-weight: 500;\n              font-size: 14px;\n              line-height: 21px;\n              color: #ffffff;\n              // border-radius: 10px;\n              padding: 10px 20px;\n              border: none;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n            }\n          }\n        }\n\n        .form-label {\n          color: #000;\n        }\n\n        width: 100%;\n\n        .heading-login {\n          label {\n            color: #000;\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
